<app-menu></app-menu>

<div class="container-fluid pt-5">
    <div class="row">
        <!--Div imagem bg-->
        <div class="col-md-6" id="img-bg"></div>
        <!--Div imagem bg-->

        <!--div do formulario-->
        <div class="col-md-6 mt-5 mb-5">
            <div class="row d-flex justify-content-center">
                <div class="col-md-6">

                    <!--Logo-->
                    <div class="d-flex justify-content-center mb-4">
                      <img
                        style="width: 100px"
                        class="d-flex justify-content-center" routerLink='/home'
                        src="https://i.imgur.com/5KOEUob.png"
                        alt="Logo repassa"
                      />
                    </div>
                    <!--Logo-->

                    <!--texto-->
                    <h3 class="text-center">Cadastre-se</h3>
                    <hr>
                    <!--texto-->

                    <!--Formulario-->
                    <div class="form-group">
                        <label for="nome">Nome</label>
                        <input [(ngModel)]='user.nome' class="form-control" type="text" name="nome" id="nome" placeholder="Seu nome">
                    </div>
                    <div class="form-group">
                        <label for="usuario">Email</label>
                        <input [(ngModel)]='user.email' class="form-control" type="text" name="usuario" id="usuario" placeholder="Seu melhor email">
                    </div>
                    <div class="form-group">
                        <label for="foto">Link da foto</label>
                        <input [(ngModel)]='user.foto' class="form-control" type="text" name="foto" id="foto" placeholder="link da sua foto">
                    </div>
                    <div class="form-group">
                        <label for="senha">Senha</label>
                        <input (input)='confirmSenha($event)' class="form-control" type="password" name="senha" id="senha" placeholder="Sua senha">
                    </div>
                    <div class="form-group">
                        <label for="confirmarSenha">Confirmar senha</label>
                        <input [(ngModel)]='user.senha' class="form-control" type="password" name="confimrarSenha" id="confirmarSenha" placeholder="Confirme sua senha">
                    </div>
                   <!--  <div class="form-group"> 
                        <label for="tipo">Tipo de usuário</label>
                        <select class="form-control" name="tipo" id="tipo">
                            <option>Selecione um tipo de usuário</option>
                            <option value="normal">normal</option>
                            <option value="administrador">Administrador</option>
                        </select>
                    </div> -->

                    <!--botões-->

                    <div class="mt-4 d-flex justify-content-center">
                        <button type="submit" class="btn mr-4" id="botaoCancelar" routerLink='/home'>Voltar</button>
                        <button  (click)='cadastrar()' type="submit" class="btn">Cadastrar</button>

                    </div>

                    <div>
                        <hr class="mt-4 mb-2">

                        <p class="text-center">
                            Já tem cadastro?  
                            <a id="linkfora" routerLink="/logar">Faça login</a>
                        </p>
                    </div>
                    <!--botões-->
                </div>
            </div>
        </div>
        <!--div do formulario-->
    </div>
</div>

<app-rodape></app-rodape>